import Text, { TEXT_SIZE_REGULAR } from '@loggi/ui/components/text';
import Col from '@loggi/ui/components/col';
import View from '@loggi/ui/components/view';
import { privatePackageTrackerModel } from 'app.models';
import PropTypes from 'prop-types';
import React from 'react';
import styles from 'shared/card/status-card/status-card.component.scss';

const BolderView = props => {
  const { text } = props;
  return (
    <View inline className={styles.textBolder}>
      {text}
    </View>
  );
};

export default function StatusMessage(props) {
  const { shipperStatus } = props;

  return (
    <Col flexDirection="column">
      <Text size="400">
        {shipperStatus && <BolderView text={shipperStatus.label} />}
      </Text>
      <Text size={TEXT_SIZE_REGULAR}>
        {shipperStatus && shipperStatus.description}
      </Text>
    </Col>
  );
}

BolderView.propTypes = {
  text: PropTypes.string.isRequired
};

StatusMessage.propTypes = {
  ...privatePackageTrackerModel
};
